function getDataDepth(element) {
  var parent = element.parentNode && element.parentNode.closest('ul, ol');
  var depth = parseInt(element.dataset.depth, 10) || 0;

  if (parent) {
    depth = parseInt(parent.dataset.depth, 10) + 1;
  }

  element.dataset.depth = depth;
  return depth;
}

export default getDataDepth;